import { AutomationCourse } from '../types';
import { module1 } from './modules/module1';
import { module2 } from './modules/module2';
import { module3 } from './modules/module3';

export const MAKE_COURSES: AutomationCourse[] = [
  {
    id: 'make-integromat-automation',
    title: 'Make (Integromat) Visual Automation',
    description: 'Master visual automation with Make (formerly Integromat). Build sophisticated workflows with a powerful visual editor, advanced data operations, and 1,000+ app integrations.',
    level: 'intermediate',
    duration: '8 hours',
    category: 'workflow-automation',
    image: '/api/placeholder/400/300',
    tags: ['Make', 'Integromat', 'Automation', 'Visual Workflow', 'Integration', 'No-Code', 'iPaaS', 'Data Transformation'],
    prerequisites: [
      'Basic understanding of automation concepts',
      'Familiarity with web applications',
      'Knowledge of APIs helpful but not required',
      'Understanding of data structures (arrays, objects)'
    ],
    objectives: [
      'Design complex visual automation workflows',
      'Use routers, iterators, and aggregators effectively',
      'Transform and manipulate data with built-in functions',
      'Implement error handling and monitoring',
      'Optimize scenarios for performance and cost',
      'Build production-ready automations',
      'Integrate with 1,000+ apps and services'
    ],
    learningOutcomes: [
      'Create sophisticated visual automation scenarios',
      'Process and transform data efficiently',
      'Handle complex routing and conditional logic',
      'Work with arrays and aggregations',
      'Implement robust error handling',
      'Monitor and optimize automation performance',
      'Deploy production-grade workflows',
      'Integrate multiple services seamlessly'
    ],
    modules: [
      module1,
      module2,
      module3
    ],
    type: 'automation'
  }
];
